import React from 'react';
import { MainView } from '@repo/ui/Views';
import { Authorization } from '@/lib/Authorization';
import { POLICIES } from '@/lib/Authorization';
import { FallbackCard } from '@repo/ui/Card';
import ApiKeysTable from '@/features/dids/components/ApiKeys/ApiKeysForDidTable';
import DidTabNav from '../components/DidTabNav';
import { useAccount } from '@/hooks/useAccount';
import { useUser } from '@repo/hooks/useUser';
import { useParams } from 'react-router';
import { useQuery } from '@apollo/client/react';
import DIDS_SHOW_Q from '../gql/show.gql';
const DidApiKeys = () => {
  const user = useUser();
  const account = useAccount();
  const accountId = account.id;
  const params = useParams();
  const didId = params.didId;

  const { loading, error, data } = useQuery(DIDS_SHOW_Q, {
    variables: {
      id: String(didId),
    },
  });

  if (error) {
    console.error(error);
  }

  return (
    <MainView title={loading ? `Loading...` : `${data?.did?.number}`} loading={loading}>
      <DidTabNav />
      <Authorization
        policyCheck={POLICIES['api_keys:index'](user)}
        fallbackView={
          <FallbackCard
            title="No Access"
            description="You do not have the permissions to view API keys."
          />
        }
      >
        {accountId && didId && <ApiKeysTable didId={didId} accountId={accountId} />}
      </Authorization>
    </MainView>
  );
};

export default DidApiKeys;
